<template>
  <div class="header-box show-flex-box-r">
    <div class="show-flex-box-r">
      <dl class="show-flex-box-r">
        <dt>
          <strong @click="tabToHome">
            <img
              src="../../assets/common/logo_white_icon.png"
              alt="德阳经开科创"
              v-if="finderStyle == 'none'"
              draggable="false"
            />
            <img
              src="../../assets/common/logo_black_icon.png"
              alt="德阳经开科创"
              v-if="finderStyle == 'white'"
              draggable="false"
            />
          </strong>
        </dt>
        <dd class="home-page-list show-flex-box-r">
          <div class="page-list show-flex-box-r">
            <ul class="show-flex-box-r">
              <li
                class="classifacation-font show-flex-box-r"
                v-for="(item, index) in headerClass"
                :key="index"
                @click="tabToJumpSubcategory(item.title)"
              >
                <strong
                  :class="{
                    'classifacation-font-white': routerInfo == item.title,
                    'white-f': routerInfo == item.title,
                  }"
                  >{{ item.name }}</strong
                >
              </li>
            </ul>
          </div>
          <div class="user-info-list show-flex-box-r">
            <div
              class="user-info show-flex-box-r"
              v-if="logined"
              @click="tabToPersonalCenter"
            >
              <span v-if="userInfo && userInfo.avatar">
                <img :src="userInfo.avatar" alt="德阳经开科创" draggable="false" />
              </span>
              <h1 class="hide-line1" v-if="userInfo.nickname">
                {{ userInfo.nickname }}
              </h1>
            </div>
            <!-- <strong class="apply-trial show-flex-box-r show-flex-center" @click="tabToApplyTrial" v-else>
              <span>申请试用</span>
            </strong> -->
          </div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import regex from "@/filter/regex";

export default {
  name: "mars_box_home_header_cpn",
  data() {
    return {
      headerClass: [
        { name: "首页", title: "home" },
        // { name: "火星轻课", title: "light_course" },
        { name: "课程体系", title: "course_home" },
        { name: "科学视频", title: "video_home" },
        { name: "编程创作", title: "scratch" },
        { name: "新闻中心", title: "news_home" },
        // {'name': '官方公告', 'title': 'forum_home'},
        { name: "关于我们", title: "about_home" },
      ],
      routerInfo: "home",
      finderStyle: "none",
      defaultType: "home",
      logined: false,
      userInfo: false,
    };
  },
  computed: {
    listenToken: function () {
      return this.$store.state.token;
    },
    listenUserInfo: function () {
      return this.$store.state.user;
    },
  },
  created() {
    this.isGetUserInfo();
  },
  mounted() {
    this.reqRouterPath();
    this.getOrderCount();
  },
  methods: {
    tabToPersonalCenter: function () {
      let toWhere = "/personal/set/home/project";
      this.$router.push({ path: toWhere });
    },
    tabToHome: function () {
      let toWhere = "/";
      this.$router.push({ path: toWhere });
    },
    tabToApplyTrial: function () {
      $("body").css({ overflow: "hidden" });
      this.$store.commit("SET_ISTRIAL", true);
    },
    tabToChargeCourse: function () {
      // $('body').css({"overflow":'hidden'});
      let userToken = this.$store.state.token;
      let tokenStatus = regex.isTrueResult(userToken);

      if (tokenStatus) {
        // 跳转
        this.$elementMsg.success({
          message: "兑换成功",
          showClose: true,
          customClass: "pop-class-success",
          duration: 3000,
        });
      } else {
        this.$elementMsg.error({
          message: "请登录后兑换",
          showClose: true,
          customClass: "pop-class-error",
          duration: 3000,
        });
      }
      // this.$store.commit('SET_ISCHARGE',true);     //弹出兑换弹窗
    },
    isGetUserInfo: function () {
      let userToken = this.$store.state.token;
      let tokenStatus = regex.isTrueResult(userToken);

      if (tokenStatus) {
        this.getUserInfo();
        this.checkUserStatus();
      }
    },
    checkUserStatus: function () {
      let userStore = this.$store.state.user;
      let userStatus = regex.isTrueResult(userStore);

      if (userStatus) {
        this.logined = regex.isTrueResult(this.$store.state.loginStatus);
        this.userInfo = this.formatUserInfoByType(userStore);
      } else {
        this.userInfo = {};
        this.logined = regex.isTrueResult(this.$store.state.loginStatus);
      }
    },
    //用户信息数据类型转换
    formatUserInfoByType: function (userStore) {
      let dataType = typeof userStore;
      let userObj = userStore;
      // if (dataType == 'string') {
      //   userObj = $.parseJSON(userStore);
      //   console.log(userObj);
      // }

      return userObj;
    },
    getUserInfo: function () {
      let vSelf = this;

      this.$client
        .getUserInfo()
        .then((res) => {
          if (res.code === "200" || res === 200) {
            vSelf.userInfo = res.data;
            let curUserInfo = vSelf.saveUserInfo(res.data);
            vSelf.$store.commit("GET_USER", curUserInfo);
          }
        })
        .catch((err) => {});
    },
    // 保存用户信息
    saveUserInfo: function (userObj) {
      let userInfo;

      userInfo = {
        nickname: userObj.nickname,
        avatar: userObj.avatar,
        is_agents: regex.isTrueResult(userObj.is_agents),
        is_teacher: regex.isTrueResult(userObj.is_teacher),
        agents_teacher_max_num: userObj.agents_teacher_max_num,
        agents_teacher_num: userObj.agents_teacher_num,
      };
      return userInfo;
    },
    listenScroll: function () {
      var _Vself = this;
      if (_Vself.routerInfo != "home") {
        _Vself.changeHeaderToWhite();
        $(".header-box").css({ background: "#fff" });
      } else {
        _Vself.resetHeaderChange();
        $(".header-box").css({ background: "none" });
        $(window).scroll(function (event) {
          var bannerHeight = parseInt($(".home-banner-box").css("height"));
          if (_Vself.routerInfo == "home") {
            var scrollTop = $(window).scrollTop();
            var curColor = _Vself.changeCurColor(
              (scrollTop / bannerHeight).toFixed(2)
            );
            $(".header-box").css({
              background: curColor,
              "box-shadow": "0px 0px 1px 0px rgba(127,127,127,0.2)",
            });
          }
          if (
            scrollTop >= ((bannerHeight - 60) * 2) / 5 ||
            _Vself.routerInfo != "home"
          ) {
            _Vself.changeHeaderToWhite();
          } else {
            _Vself.resetHeaderChange();
          }
        });
      }
    },
    changeCurColor: function (i) {
      return "rgba(255,255,255," + i + ")";
    },
    //将导航栏变为白色背景
    changeHeaderToWhite: function () {
      this.finderStyle = "white";
      // $('.header-box').css({'background':'#fff','box-shadow':'0px 0px 1px 0px rgba(127,127,127,0.2)'});
      $(".course-redemption").addClass("course-redemption-white");
      if (this.logined) {
        $(".user-info").addClass("user-info-white");
      } else {
        $(".apply-trial").addClass("apply-trial-white");
      }
      $(".classifacation-font").addClass("classifacation-font-white");
    },
    //重置导航栏颜色
    resetHeaderChange: function () {
      this.finderStyle = "none";
      $(".header-box").css("box-shadow", "none");
      $(".course-redemption").removeClass("course-redemption-white");
      if (this.logined) {
        $(".user-info").removeClass("user-info-white");
      } else {
        $(".apply-trial").removeClass("apply-trial-white");
      }
      $(".classifacation-font").removeClass("classifacation-font-white");
    },
    tabToJumpSubcategory: function (pathName) {
      let routerParams = this.$route.params.type;

      if (pathName == "home") {
        let toWhere = "/";
        this.$router.push({ path: toWhere });
      } else if (pathName == "light_course") {
        let toWhere = "/light_course";
        this.$router.push({ path: toWhere });
      } else if (pathName == "course_home") {
        let toWhere = "/course_system/course_home";
        this.$router.push({ path: toWhere });
      } else if (pathName == "video_home") {
        let toWhere = "/scientific_video/video_home";
        this.$router.push({ path: toWhere });
      } else if (pathName == "news_home") {
        if (routerParams == "newsDetail") {
          this.goBack();
        } else {
          let toWhere = "/news_center/news_center/newsHome";
          this.$router.push({ path: toWhere });
        }
      } else if (pathName == "forum_home") {
        let toWhere = "/forum/forum_home/forum";
        this.$router.push({ path: toWhere });
      } else if (pathName == "about_home") {
        let toWhere = "/about_us/about_home/home";
        this.$router.push({ path: toWhere });
      } else if (pathName == "scratch") {
        var href = this.scratchUrl;
        window.open(href, "_blank");
      }
    },
    reqRouterPath: function () {
      this.routerInfo = this.$route.name;
      this.listenScroll();
    },
    goBack: function () {
      this.$router.go(-1);
    },
    getOrderCount: function () {
      this.$client
        .getOrderCount()
        .then((res) => {
          this.scratchUrl = res.data.scratch_plugin_url;
        })
        .catch((err) => {});
    },
  },
  watch: {
    $route: function (from) {
      this.reqRouterPath();
    },
    listenToken: function () {
      let tokenStatus = regex.isTrueResult(this.listenToken);

      if (tokenStatus) {
        // this.getUserInfo();
      } else {
        this.logined = false;
      }
    },
    listenUserInfo: function () {
      this.userInfo = this.listenUserInfo;
      this.checkUserStatus();
    },
  },
};
</script>

<style lang="less" scoped>
.set-color-white(@color) when (@color=#fff) {
  font-weight: 800;
  color: @color;
}

.set-color-white(@color) when (@color=#FF7800) {
  font-weight: 800;
  color: @color;
}

.header-box {
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  // min-width: 1400px;
  height: 60px;
  z-index: 999;
  justify-content: center;
  // border: 1px solid red;
  // background: #fff;
  & > div {
    // padding-left: 10%;
    width: 100%;
    height: 60px;
    // padding-right: 160px;
    // padding-left: 201px;
    // padding-right: 359px;
    // border: 1px solid blue;
    & > dl {
      // width: 100%;
      padding-left: 10%;
      padding-right: 18%;
      flex-grow: 1;
      // justify-content: center;
      align-items: center;
      & > dt {
        // padding-left: 10.5%;
        & > strong {
          display: block;
          width: 110px;
          padding-right: 50px;
          cursor: pointer;
          & > img {
            width: 100%;
          }
        }
      }

      & > .home-page-list {
        width: 100%;
        flex-grow: 1;
        // justify-content: space-between;
        align-items: center;
        & > .page-list {
          width: 100%;
          // flex-grow: 1;
          & > ul {
            width: 100%;
            align-items: center;
            & > .classifacation-font {
              white-space: nowrap;
              padding-right: 54px;
              & > strong {
                display: block;
                font-size: 18px;
                color: #fff;
                font-weight: 500;
                cursor: pointer;
                transition: 0.3s all;
              }
              & > .white-f {
                .set-color-white(#fff);
              }
              & > strong:hover {
                font-weight: 800;
              }
            }
            & > .classifacation-font-white {
              padding-right: 54px;
              & > strong {
                display: block;
                font-size: 18px;
                color: #191d21;
                font-weight: 500;
                cursor: pointer;
                transition: 0.3s all;
              }
              & > .white-f {
                .set-color-white(#FF7800);
              }
              & > strong:hover {
                color: #ff7800;
              }
            }
          }
        }
        & > .user-info-list {
          flex-shrink: 0;
          //banner 图内
          & > span {
            width: 118px;
            height: 38px;
            margin-right: 20px;
            border: 1px solid #fff;
            border-radius: 20px;
            cursor: pointer;
            transition: 0.3s all;
            & > strong {
              display: block;
              font-size: 18px;
              color: #fff;
              font-weight: 500;
              line-height: normal;
              transition: 0.3s all;
            }
          }
          & > span:hover {
            width: 118px;
            height: 38px;
            background: #fff;
            & > strong {
              display: block;
              font-size: 18px;
              color: #ff7800;
              font-weight: 500;
              line-height: normal;
            }
          }
          & > strong {
            width: 118px;
            height: 38px;
            margin-right: 20px;
            border: 1px solid #fff;
            border-radius: 20px;
            cursor: pointer;
            transition: 0.3s all;
            & > span {
              display: block;
              font-size: 18px;
              color: #fff;
              font-weight: 500;
              line-height: normal;
              transition: 0.3s all;
            }
          }
          & > strong:hover {
            width: 118px;
            height: 38px;
            background: #fff;
            & > span {
              display: block;
              font-size: 18px;
              color: #ff7800;
              font-weight: 500;
              line-height: normal;
            }
          }
          //banner 图外
          & > .course-redemption-white {
            width: 118px;
            height: 38px;
            margin-right: 20px;
            border: 1px solid #ff7800;
            border-radius: 20px;
            cursor: pointer;
            transition: 0.3s all;
            & > strong {
              display: block;
              font-size: 18px;
              color: #ff7800;
              font-weight: 500;
              line-height: normal;
              transition: 0.3s all;
            }
          }
          & > .course-redemption-white:hover {
            width: 118px;
            height: 38px;
            background: #ff7800;
            & > strong {
              display: block;
              font-size: 18px;
              color: #fff;
              font-weight: 500;
              line-height: normal;
            }
          }
          & > .user-info {
            width: 130px;
            align-items: center;
            cursor: pointer;
            & > span {
              overflow: hidden;
              display: flex;
              width: 40px;
              height: 40px;
              border-radius: 100%;
              overflow: hidden;
              margin-right: 13px;
              box-shadow: 0px 1px 1px #dedede;
              & > img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                flex-grow: 1;
              }
            }
            & > h1 {
              display: block;
              font-size: 18px;
              color: #fff;
              font-weight: 500;
              transition: 0.3s all;
              cursor: pointer;
            }
          }
          & > .user-info-white {
            width: 130px;
            align-items: center;
            & > span {
              width: 40px;
              height: 40px;
              border-radius: 100%;
              overflow: hidden;
              margin-right: 13px;
              & > img {
                height: 100%;
                object-fit: cover;
                flex-grow: 1;
              }
            }
            & > h1 {
              display: block;
              font-size: 18px;
              color: #191d21;
              font-weight: 500;
              transition: 0.3s all;
            }
          }
          & > .apply-trial-white {
            width: 118px;
            height: 38px;
            margin-right: 20px;
            border: 1px solid #ff7800;
            border-radius: 20px;
            cursor: pointer;
            transition: 0.3s all;
            & > span {
              display: block;
              font-size: 18px;
              color: #ff7800;
              font-weight: 500;
              line-height: normal;
              transition: 0.3s all;
            }
          }
          & > .apply-trial-white:hover {
            width: 118px;
            height: 38px;
            background: #ff7800;
            & > span {
              display: block;
              font-size: 18px;
              color: #fff;
              font-weight: 500;
              line-height: normal;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/mars_box_home_header_cpn.vue